export default class UserInfo{
    constructor () {
        this.isLogined=false
        /**
         * 认证等级
         * @type {string}
         */
        this.authenLevel=""
        /**
         * 用户手机 脱敏
         * @type {string}
         */
        this.employeeMobile=""
        /**
         * 用户手机 加密
         * @type {string}
         */
        this.encodeEmployeeMobile=""
        /**
         * 用户的ID card 加密
         * @type {string}
         */
        this.encodeIdNumber=""
        /**
         * 用户姓名 加密
         * @type {string}
         */
        this.encodeRealName=""
        /**
         * 用户的ID card 脱敏
         * @type {string}
         */
        this.idNumber=""
        /**
         * 用户的名字 脱敏
         * @type {string}
         */
        this.realName=""
        /**
         * 用户类型 ,user为普通, manager为法人
         * @type {string}
         */
        this.type=""
        /**
         * 用户ID,数据ID
         * @type {string}
         */
        this.uuid=""
    }
}